import type { editor } from 'monaco-editor/esm/vs/editor/editor.api';

interface Theme extends editor.IStandaloneThemeData {
  name: string;
}

const lightTheme: Theme = {
  name: 'ds-light',
  base: 'vs',
  inherit: true,
  rules: [],
  colors: {
    'editorLineNumber.foreground': '#37363F',
    'editorGutter.background': '#F9F9F9',
  },
};

const readOnlyTheme: Theme = {
  name: 'ds-read-only',
  base: 'vs',
  inherit: false,
  rules: [],
  colors: {
    'editorLineNumber.foreground': '#37363F',
    'editorGutter.background': '#F9F9F9',
    'editor.background': '#f1f1f3',
    'editor.foreground': '#717173',
  },
};

export const themes = {
  light: lightTheme,
  readOnly: readOnlyTheme,
};
